import React from "react";
import { EMAIL } from "../site/constants";
import ContentPage, { Block, BulletList } from "../components/ContentPage";

export default function ZakelijkPage() {
  return (
    <ContentPage
      title="Voor bedrijven en organisaties"
      lead="Ook bedrijven, stichtingen en organisaties kunnen via Suriwebwinkel producten laten bezorgen in Suriname."
      ctaLabel="Vraag een zakelijke offerte aan"
      ctaHref={`mailto:${EMAIL}?subject=${encodeURIComponent(
        "Zakelijke offerte Suriwebwinkel"
      )}`}
      secondaryLabel="Contact"
      secondaryTo="/contact"
    >
      <Block title="Denk bijvoorbeeld aan">
        <BulletList
          items={[
            "Personeelspakketten",
            "Relatiegeschenken",
            "Kerstpakketten",
            "Donaties in producten",
            "Ondersteuning van gezinnen",
            "Producten voor scholen of instellingen",
            "Cadeaupakketten voor klanten",
            "Grotere groepsbestellingen",
          ]}
        />
        <p>
          Voor zakelijke of grotere bestellingen kun je contact opnemen met ons
          team voor een persoonlijke offerte.
        </p>
      </Block>
    </ContentPage>
  );
}
